import dayjs from 'dayjs';

export function reverseDateFormat(date: string, format = 'YYYY/MM/DD') {
  if (!date.includes('/')) {
    return dayjs(date).format(format);
  } else {
    return date.split('/').reverse().join('/');
  }
}
